import { useEffect, useRef, useState, useCallback } from 'react';
import { io } from 'socket.io-client';
import { rabbitmqApi, getRabbitmqBaseUrl } from '../../../../services/rabbitmqServices/rabbitmqService';

export function useRabbitmqLive() {
  const [snapshot, setSnapshot] = useState(null);
  const [connected, setConnected] = useState(false);
  const [isDegraded, setIsDegraded] = useState(false);
  const socketRef = useRef(null);

  const fetchInitialSnapshot = useCallback(async () => {
    try {
      const data = await rabbitmqApi.getSnapshot();
      if (data && !data.error) {
        setSnapshot(data);
        setIsDegraded(false);
      } else if (data && data.error) {
        setIsDegraded(true);
      }
    } catch (err) {
      console.warn('Initial REST snapshot fetch failed:', err.message);
      setIsDegraded(true);
    }
  }, []);

  useEffect(() => {
    // 1. Initial snapshot fetch via authenticated REST API
    fetchInitialSnapshot();

    // 2. Connect to Socket.IO /rabbitmq namespace
    const baseUrl = getRabbitmqBaseUrl();
    const socketEndpoint = `${baseUrl}/rabbitmq`;
    const socket = io(socketEndpoint, {
      transports: ['websocket', 'polling'],
      reconnectionAttempts: 30,
      reconnectionDelay: 1000,
    });
    socketRef.current = socket;

    socket.on('connect', () => {
      setConnected(true);
      setIsDegraded(false);
    });

    socket.on('disconnect', () => {
      setConnected(false);
    });

    socket.on('rabbitmq:snapshot', (data) => {
      if (data && data.error) {
        setIsDegraded(true);
      } else {
        setSnapshot(data);
        setIsDegraded(false);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [fetchInitialSnapshot]);

  return { snapshot, connected, isDegraded, reloadSnapshot: fetchInitialSnapshot };
}
